import React, {Fragment} from "react";
import {Input} from "reactstrap";
import StepButton from "components/Step/StepButton";
import StepQuestion from "components/Step/StepQuestion";
import * as ValidationTemplate from "utils/ValidationRule";
import StepFeedback from "components/Step/StepFeedback";
import ValidationMethods from "utils/ValidationMethods";
import StepInputLabel from "components/Step/StepInputLabel";

export default class MsisdnCaptureStep extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.yupRules = {};
        this.immediateValidation = false;
        this.scheduledValidation = null;
        this.verb = this.props.value && this.props.value.length > 0 ? "confirm" : "input";

        let validations = [{
            yupRule: ValidationTemplate.getCellphoneNumberRule("Mobile", true),
            field: "msisdn",
            value: this.props.value
        }];

        let errors = ValidationMethods.validateInitial(this, validations);
        this.state = {
            errors: errors
        };
    }

    onChange(e) {
        let value = e.target.value;
        ValidationMethods.validateOnChange(this, "msisdn", value);

        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    isInvalid(key) {
        return this.state.errors[key] !== undefined && this.state.errors[key].length > 0
    }

    render() {
        return <Fragment>
            <StepQuestion>
                {this.props.questionText || "Please " + this.verb + " your South African mobile number:"}
            </StepQuestion>
            <StepInputLabel>
                Mobile Number
            </StepInputLabel>
            <Input
                type={"text"}
                placeholder={this.props.placeholder || "eg. 0821234567"}
                value={this.props.value}
                onChange={this.onChange.bind(this)}
                invalid={this.isInvalid("msisdn")}
            />
            <StepFeedback>
                {this.state.errors.msisdn}
            </StepFeedback>
            <StepButton
                disabled={Object.keys(this.state.errors).length > 0}
                onClick={this.props.onNextClick}
            >
                Next
            </StepButton>
            <StepButton
                color={"secondary"}
                onClick={this.props.onBackClick}
            >
                Back
            </StepButton>
        </Fragment>
    }
}
